import _styled from "styled-components";
/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/no-onchange */
/* The following rule will be deprecated in a future version of eslint-plugin-jsx-a11y.
 * https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/issues/398#issuecomment-729113622
 */
var _excluded = ["$completed", "children", "className", "description", "error", "id", "label", "labelHidden", "options", "required", "value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { FieldWrapper } from "../FieldWrapper/FieldWrapper";
import * as styles from "./DropDown.styles";
import { getAriaDescribedByForInputField } from "../../../utils/getAriaDescribedByForInputField";
export var DROP_DOWN_CLASSNAME = 'drop-down__input';
var getSelectOptionsElements = function getSelectOptionsElements(options) {
  return options.map(function (_ref) {
    var disabled = _ref.disabled,
      optionLabel = _ref.optionLabel,
      optionValue = _ref.optionValue;
    return /*#__PURE__*/React.createElement("option", {
      disabled: disabled,
      key: "".concat(optionValue).concat(optionLabel),
      value: optionValue
    }, optionLabel);
  });
};
var getSelectOptions = function getSelectOptions(options) {
  if (Array.isArray(options)) {
    return getSelectOptionsElements(options);
  }
  return Object.keys(options).map(function (optName) {
    return /*#__PURE__*/React.createElement("optgroup", {
      key: optName,
      label: optName
    }, getSelectOptionsElements(options[optName]));
  });
};
export var DropDown = function DropDown(_ref2) {
  var _ref2$$completed = _ref2.$completed,
    $completed = _ref2$$completed === void 0 ? false : _ref2$$completed,
    children = _ref2.children,
    className = _ref2.className,
    description = _ref2.description,
    error = _ref2.error,
    id = _ref2.id,
    label = _ref2.label,
    _ref2$labelHidden = _ref2.labelHidden,
    labelHidden = _ref2$labelHidden === void 0 ? false : _ref2$labelHidden,
    options = _ref2.options,
    required = _ref2.required,
    value = _ref2.value,
    props = _objectWithoutProperties(_ref2, _excluded);
  var fieldId = "".concat(id, "-select");
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(FieldWrapper, {
    $completed: $completed,
    description: description,
    error: error,
    fieldId: fieldId,
    label: label,
    labelHidden: labelHidden
  }, /*#__PURE__*/React.createElement(_StyledSelect, _extends({
    "aria-describedby": getAriaDescribedByForInputField({
      fieldId,
      description,
      error
    }),
    "aria-invalid": !!error,
    "aria-required": required,
    className: DROP_DOWN_CLASSNAME,
    id: fieldId,
    required: required,
    value: value
  }, props, {
    $_css: styles.select
  }), getSelectOptions(options))));
};
var _StyledSelect = /*#__PURE__*/_styled("select").withConfig({
  displayName: "DropDown___StyledSelect",
  componentId: "sc-sr6e0t-0"
})(["", ""], function (p) {
  return p.$_css;
});